/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Error_Chat_BlockedInputs */



/**
* | output |
* | --- |
* | "This chat has been blocked due to a compliance violation." |
*
* @param {Distillation_Error_Chat_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_error_chat_blocked = /** @type {((inputs?: Distillation_Error_Chat_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Error_Chat_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat wurde aufgrund eines Compliance-Verstoßes gesperrt.")
	return /** @type {LocalizedString} */ ("This chat has been blocked due to a compliance violation.")
});